




































import Vue from "vue";
import { mapActions, mapState } from "vuex";
import iwModal from "@/shared/components/Modal.vue";
import { updateClassified } from "@/shared/scripts/ValidateData";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwModal: iwModal,
    },

    props: {
        isVisible: {
            type: Boolean,
            required: true
        }
    },

    computed: {
        ...mapState("FormModule", ["currentStep", "steps"]),
        ...mapState("CustomersModule", ["currentCustomer"])
    },

    methods: {
        ...mapActions("CustomersModule", ["updateCustomer"]),
        ...mapActions({
            goToNextStep: "StepsWizard/next"
        }),

        closeModal: function() {
            this.$store.commit("CustomersModule/closeChangeCustomerPhoneAlertModal");
        },
        openNewCustomerModal: function() {
            this.closeModal();
            this.$emit("open-new-customer-modal");
        },
        applyChange: function() {
            this.updateCustomer(this.currentCustomer).then(success => {
                if (success) {
                    updateClassified((success: boolean) => {
                        if(success) {
                            this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", false);
                            this.$emit("phone-changes-applied");
                        }
                    });
                }
                this.closeModal();
            }).catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()));

        }
    }
});

